<template>
    <va-create-layout>
        <ShipmentEventShipmentItemTaxWithheldCharge-form
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemTaxWithheldCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
